import { render } from "./ChangePasswordComponent.vue?vue&type=template&id=792304d8&ts=true"
import script from "./ChangePasswordComponent.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__